export const UUID_PATTERN = '[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}';

const UUID_RE = new RegExp(`^${UUID_PATTERN}$`, 'i');

export const isUuid = (value: string): boolean => UUID_RE.test(value);
